/**
 * @generated SignedSource<<30290887f3131c0ad0d5bcd1ca31c747>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProblemDifficultyLevelEnum = "high" | "highest" | "low" | "lowest" | "medium" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type BookScrapUpdateDialog_bookScrap$data = {
  readonly difficultyLevel: ProblemDifficultyLevelEnum | null;
  readonly id: string;
  readonly problemBookPage: number;
  readonly problemNumber: string;
  readonly problemTex: string | null;
  readonly solutionBookPage: number | null;
  readonly solutionTex: string | null;
  readonly unitD: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "BookScrapUpdateDialog_bookScrap";
};
export type BookScrapUpdateDialog_bookScrap$key = {
  readonly " $data"?: BookScrapUpdateDialog_bookScrap$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookScrapUpdateDialog_bookScrap">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookScrapUpdateDialog_bookScrap",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UnitD",
      "kind": "LinkedField",
      "name": "unitD",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "difficultyLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "problemBookPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "problemNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "problemTex",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "solutionBookPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "solutionTex",
      "storageKey": null
    }
  ],
  "type": "BookScrap",
  "abstractKey": null
};
})();

(node as any).hash = "e005ace2eb6c7f2a7aaa19a560eff17e";

export default node;
